export default function ContactSection(){

  return <>
    <form>
      Name <input></input><br/>
      Email <input></input><br/>
      Phone <input></input><br/>
      <button type="submit">Submit</button>
    </form>
  </>
}